<app-profile-header></app-profile-header>
<section class="body-section">
    <div class="container">
        <main>
            <div class="Transaction-table mobile-filter">
                <div class="d-flex align-items-center table-title-div justify-content-end mobile-filter">
                    <ul>
                        <li>
                            <p-dropdown [style]="{'width':'180px'}" inputId="categoryType" [options]="catList"
                                [filter]="true" placeholder="Select Category" optionLabel="label" [showClear]="true"
                                (onChange)="onselectGetCategory($event)"></p-dropdown>

                        </li>
                        <li>
                            <p-dropdown [autoDisplayFirst]="false" [style]="{'width':'180px'}" inputId="ageGroup"
                                [options]="ageList" [filter]="true" placeholder="Select Age Group" optionLabel="label"
                                [showClear]="true" (onChange)="onAgeGroupSelect($event)"></p-dropdown>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-12 right-section-top-bar px-4">
                <div (click)="filterDialog()" class="mobile-fliter-icon">
                    <i class="bx bx-filter-alt"></i>
                    Filters
                </div>
            </div>
            <div class="bottom-container Transaction-table ">
                <div class="box transaction-box Rankinghistory">
                    <div class="header-container">
                        <h3 class="section-header">Ranking History
                        </h3>
                    </div>

                    <div class="table-div">
                        <p-table class="expandable" #dt [value]="scoreList" [paginator]="true" [rows]="10" [lazy]="true"
                            [scrollable]="true" scrollHeight="auto" scrollDirection="both"
                            (onLazyLoad)="getUserScore($event)" [totalRecords]="totalRecords" pageLinkSize="3"
                            paginatorDropdownAppendTo="body" [loading]="loading"
                            [rowsPerPageOptions]="paginationOption">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="display: table-cell!important;">Date</th>
                                    <th style="display: table-cell!important;">Tournament Name</th>
                                    <th style="display: table-cell!important;"> Categories</th>
                                    <th style="display: table-cell!important;"> Age Group</th>
                                    <th style="display: table-cell!important;">Place</th>
                                    <th style="display: table-cell!important;"> Point</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-result>
                                <tr class="row_1 ">
                                    <td> <span class="mobile-heading-lable"> Date: </span> {{result.startdate |
                                        date:'dd/MM/yyyy' }}</td>
                                    <td> <span class="mobile-heading-lable"> Tournament Name: </span>
                                        {{result.tournamentName}}</td>
                                    <td> <span class="mobile-heading-lable"> Categories:&nbsp;&nbsp; </span>
                                        {{result.categoryName}}</td>
                                    <td> <span class="mobile-heading-lable"> Age Group:&nbsp;&nbsp; </span>
                                        {{result.agegroupName}}</td>
                                    <td><span class="mobile-heading-lable"> Place:&nbsp;&nbsp; </span>
                                        {{result.playerplace}}</td>
                                    <td><span class="mobile-heading-lable"> Point:&nbsp;&nbsp; </span>
                                        {{result.pointsEarn}}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="6">
                                        Result not found.
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="summary">
                                <div class="p-d-flex p-ai-center p-jc-between">
                                    In total there are
                                    {{totalRecords }} Results.
                                </div>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </main>
    </div>
</section>

<p-dialog header="Filter" [(visible)]="filtervisible" [modal]="true" [style]="{ width: 'calc(100% - 30px)' }"
    [draggable]="false" [resizable]="false" id="filter-div">

        <ul>
            <li>
                <p-dropdown [style]="{'width':'100%'}" inputId="categoryType" [options]="catList" appendTo="body"
                    [filter]="true" placeholder="Select Category" optionLabel="label" [showClear]="true"
                    (onChange)="onselectGetCategory($event)"></p-dropdown>

            </li>
            <li>
                <p-dropdown [autoDisplayFirst]="false" [style]="{'width':'100%'}" inputId="ageGroup" appendTo="body"
                    [options]="ageList" [filter]="true" placeholder="Select Age Group" optionLabel="label"
                    [showClear]="true" (onChange)="onAgeGroupSelect($event)"></p-dropdown>
            </li>
        </ul>

    <ng-template pTemplate="footer">
        <p-button (click)="filtervisible = false" label="Submit" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>